export default "__VITE_ASSET__DK5NTH6Y__"